import { useState, useEffect } from 'react';
import customerService from '../../services/customerService';
import jobService from '../../services/jobService';
import { getFranchiseeIdForDataLoading } from '../services/appHelpers';
import { DATA_LOAD_LIMITS, JOB_STATUS } from '../utils/appConstants';

export const useAppData = (user) => {
  const [customers, setCustomers] = useState([]);
  const [jobs, setJobs] = useState([]);
  const [customerCount, setCustomerCount] = useState(0);

  // Load data using MySQL API calls
  const loadData = async (user) => {
    if (!user) return;

    try {
      const franchiseeId = getFranchiseeIdForDataLoading(user);
      
      // Only load data if we have a valid franchisee context
      if (!franchiseeId) {
        console.log('No franchisee context available, skipping data load');
        setCustomers([]);
        setJobs([]);
        setCustomerCount(0);
        return;
      }
      
      // Load customer count for dashboard (CustomerList component handles its own data)
      try {
        const count = await customerService.getCustomerCount(franchiseeId);
        setCustomerCount(count);
        setCustomers([]); // CustomerList manages its own customers now
      } catch (error) {
        console.error('Failed to load customer count:', error);
        setCustomerCount(0);
        setCustomers([]);
      }

      // Load jobs
      const jobsResponse = await jobService.getJobs(franchiseeId, {
        sortBy: 'scheduled_date',
        sortOrder: 'DESC',
        limit: DATA_LOAD_LIMITS.JOBS
      });
      
      if (jobsResponse.jobs) {
        setJobs(jobsResponse.jobs);
      }
    } catch (error) {
      console.error('Error loading data:', error);
      // Don't clear data on error, just log it
    }
  };

  // Load data when user changes
  useEffect(() => {
    loadData(user);
  }, [user]);

  // Refresh data function (replaces real-time listeners)
  const refreshData = async () => {
    if (user) {
      await loadData(user);
    }
  };

  return {
    customers,
    jobs,
    customerCount,
    setCustomers,
    setJobs,
    setCustomerCount,
    refreshData
  };
};